import { MdUpdate } from 'react-icons/md';

import { selectUserId } from '@entities/user';
import { useAppDispatch, useAppSelector } from '@shared/model';
import {
  resetState,
  selectGenerationState,
  setPrefix,
  useResetGenerationStateMutation,
} from '@entities/generation-state';
import { iconStyle, inputStyle } from './MenuHeader.tailwind';
import { ChangeEvent } from 'react';
import { RESET_STATE_MODAL_TAG } from './constants';
import { ConfirmationModal, selectModalState, showModal } from '@shared/ui/modals';

const MenuHeader = () => {
  const dispatch = useAppDispatch();

  const userId = useAppSelector(selectUserId);
  const { prefix, isLoading } = useAppSelector(selectGenerationState);
  const { isOpen, tag } = useAppSelector(selectModalState);
  const [resetStateAsync] = useResetGenerationStateMutation();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const prefix = event.currentTarget.value;

    dispatch(setPrefix(prefix));
  };

  const handleReset = async () => {
    if (isLoading) {
      return;
    }

    const { data: isSuccess } = (await resetStateAsync(userId)) as unknown as { data: boolean };

    if (isSuccess) {
      dispatch(resetState());
    }
  };

  const handleShowResetModal = () => {
    dispatch(showModal(RESET_STATE_MODAL_TAG));
  };

  const isShowModal = isOpen && tag === RESET_STATE_MODAL_TAG;

  return (
    <>
      <div className="flex-center-between">
        <input
          className={inputStyle}
          placeholder="Invoice - {0000} - {00}"
          value={prefix}
          onChange={handleChange}
          data-id="input-Prefix"
        />
        <div className={iconStyle} onClick={handleShowResetModal} data-id="div-Reset">
          <MdUpdate />
        </div>
      </div>

      {isShowModal ? (
        <ConfirmationModal
          title="Confirmation"
          message="Are you sure that you want to reset uploaded .xlsx file?"
          onConfirm={handleReset}
        />
      ) : null}
    </>
  );
};

export default MenuHeader;
